<template lang="pug">
UiStack(vertical)
  UiStack
    UiStackItem(fill)
      .ui-card-section-title {{ $t("companies.approvers.target_verificators") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="openAssignApprover"
        icon="Plus"
      ) {{ $t("companies.approvers.assign_verificator") }}
  RestTable(
    namespace="target_verificators"
    :headers="headers"
    ref="TargetVerificatorsTable"
    :fetch-handler="getData"
    disablePagination
  )
    template(#cell:actions="{ item }")
      UiButton(
        size="sm"
        variant="smooth-danger"
        @click="deassign(item)"
      ) Remove
  AssignApproverModal(
    ref="AssignApproverModal"
    @closed="reload"
  )
</template>

<script>
import ApiApprovers from "@/api/approvers.js";
import AssignApproverModal from "@/modals/Approvers/assignApprovers.vue";

export default {
  components: {
    AssignApproverModal,
  },
  props: ["target", "target_id"],

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          cellClass: "text-nowrap",
        },
        {
          key: "approver_name",
          label: "Name",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reload() {
      this.$refs.TargetVerificatorsTable.fetchData();
    },

    getData(params, config) {
      return ApiApprovers.fetchTargetVerificators(
        this.$route.params.id,
        this.target,
        this.target_id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.verificators,
          meta: resp.data.meta,
        };
      });
    },

    openAssignApprover() {
      this.$refs.AssignApproverModal.open(
        this.target,
        this.target_id,
        "verificator",
      );
    },

    deassign(item) {
      return new Promise((res) => {
        ApiApprovers.deassignApprover(
          this.$route.params.id,
          item.id,
          this.target,
          this.target_id,
          "verificator",
        ).then((resp) => {
          this.reload();
        });
      });
    },
  },
};
</script>
